module.exports = __webpack_public_path__ + "img/JT_icons01_64px_SeenOn.a46d2d3a.svg";